import { PaymentsUnion } from 'ggApp/types/graphql';

export enum ActionTypes {
    SET_SHOULD_SHOW_SHEET = 'SET_SHOULD_SHOW_SHEET',
}

export type ActionType = keyof typeof ActionTypes;

export type PaymentContentType = PaymentsUnion | null | undefined;

export interface PayloadInterface {
    shouldShow?: boolean;
    content?: PaymentContentType;
}

export interface PaymentsAction {
    type: ActionType;
    payload: PayloadInterface;
}

export default ActionTypes;
